<template>
  <div class="voc-detail-container">
    <div class="article-title">VOC：</div>
    <div class="article-content">
      挥发性有机物指在常温常压下容易挥发的有机化学物质，它们广泛存在于日常生活和工业生产中。其来源包括涂料、油漆、胶粘剂、汽车尾气、工业排放、燃料燃烧、印刷行业等各行各业。
    </div>
    <div class="article-title">常见VOC气体：</div>
    <div class="article-content">
      包括各种烃类、醛类、醇类、酮类、酯类、醚类等。例如：氯乙烯、丙酮、氨气、苯、甲苯、乙苯、间二甲苯、氯苯、氨气、环氧乙烷、丁烷、辛烷、异辛烷、丙烯腈、乙醚、乙醇、乙醛、乙烯、乙酸乙酯、苯乙烯、丁烯、异丁烯、溴、苯胺、苯酚、苯甲醛、呋喃、吡啶、硝基甲苯、硝基苯、三氯化磷等。
    </div>

    <div class="article-title">主要特点与危害：</div>
    <div class="article-content">
      <ul>
        <li>1、多数具有特殊气味，部分无色无味；</li>
        <li>2、是形成光化学烟雾和细颗粒物（PM2.5）的重要前体物，加剧空气污染；</li>
        <li>
          3、长期接触可能引发头痛、疲劳、呼吸道刺激，部分VOC（如苯、甲苯）已被证实具有致癌性。
        </li>
      </ul>
    </div>

    <div class="article-title">应急处置：</div>
    <div class="article-title sub-title">泄漏初期：</div>
    <div class="article-content">
      <ul>
        <li>1、迅速撤离：立即向上风或侧风方向高处转移。绝对禁止围观。</li>
        <li>2、杜绝火源：严禁明火、吸烟、开关电器（可能产生电火花）。</li>
        <li>3、初步防护：用湿毛巾等捂住口鼻，迅速离开。</li>
      </ul>
    </div>

    <div class="article-title sub-title">应急响应阶段：</div>
    <div class="article-content">
      <ul>
        <li>1、警戒隔离：设立警戒区，疏散无关人员。 切断源头：如有可能，远程关闭阀门、堵漏。</li>
        <li>2、通风稀释：开启防爆风机，喷洒雾状水加速气体扩散。</li>
        <li>3、监测预警：必须使用VOC或可燃气体检测仪实时监测浓度，防止达到爆炸极限。</li>
        <li>
          4、专业处置：佩戴正压式呼吸器、穿防静电服。使用防爆工具，用吸附棉、沙土等围堵收集泄漏物。
        </li>
      </ul>
    </div>

    <div class="article-title sub-title">事后阶段：</div>
    <div class="article-content">
      <ul>
        <li>1、持续监测：确保现场浓度降至安全范围。</li>
        <li>2、规范清理：将吸附的污染物作为危险废物移交处理。</li>
        <li>3、调查评估：查明原因，完善预防措施。</li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  methods: {},
  components: {}
};
</script>

<style lang="scss">
.voc-detail-container {
  @include scrollar-style-bold;
  height: 100%;
  overflow-y: auto;
  padding: 20px;
  box-sizing: border-box;
  .article-title {
    font-size: 20px;
    font-weight: bold;
    margin: 10px 0;
  }
  .sub-title {
    font-size: 15px;
    font-weight: bold;
    text-indent: 10px;
    margin-left: 20px;
  }
  .article-content {
    font-size: 14px;
    text-indent: 10px;
    ul {
      margin-top: 10px;
      text-indent: 45px;
      line-height: 1.6;
    }
  }
}
</style>
